<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'location',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data"></contenttitle>
      <div style="margin-top:50px;margin-bottom:50px;position: relative;">
        <img @load="loaded" :src="addip(data.pic)" style="width: 100%;height:auto;" />
        <div class="location-box flex align-center justify-center"   :style="{left:getLocation(item.x),top:getLocation(item.y),color:data.color}" v-for="(item,i) in data.child" :key="i">
          <div class="location-dot round bg-primary"></div>
          <a :href="item.url" class="locatoin-title">{{ item.name }}</a>
        </div>
      </div>
    </div>
</template>
<script setup lang="ts" name="location">
import {defineComponent,defineProps,ref } from 'vue'
import {addip,getCol} from '@/utils/util'
defineProps({
  data:Object
})
const w=ref<Number>(0)
const h=ref<Number>(0)
const getLocation=(num:FLoat)=>{
  let v='10%'
  if(num){
    v= 'calc('+num*100+"%"+' - 15px)'
  }
  return v
}
const loaded=(event)=>{
  w.value=event.target.offsetWidth
  h.value=event.target.offsetHeight
}
</script>
<style lang="less">
  .location{
    .location-box{
        position: absolute;height:30px;
    .location-dot{
      width:10px;height:10px;margin:10px;
      animation: locatondot 1s linear infinite;
    }
    .locatoin-title{font-size: 1.2em;}
    }
  }
  @keyframes locatondot{
    0%{transform: scale(.5,.5);opacity: 1;}
    100%{transform: scale(10,10);opacity: .1;}
  }
</style>
